import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import LotNumberView from 'components/Catalog/LotNumberView';

// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <LotNumberView />
      </SiteContent>
    </ContentLayout>
  );
};
